export class Queue {
	constructor() {
		this.items = [];
	}

	// 큐에 항목 추가
	enqueue(element) {
		this.items.push(element);
	}

	// 큐에서 항목 제거
	dequeue() {
		if (this.isEmpty()) {
			return 'Queue is empty';
		}
		return this.items.shift();
	}

	// 큐가 비었는지 확인
	isEmpty() {
		return this.items.length === 0;
	}

	// 큐의 길이 반환
	size() {
		return this.items.length;
	}
	// 큐를 비우기
	clear() {
		this.items = [];
	}
}
